const UPLOAD_BOX_ERROR_TYPE = {
    GENERIC: 'error-type-generic',
    COUNTDOWN: 'error-type-countdown',
};

export { UPLOAD_BOX_ERROR_TYPE };
